import { render, staticRenderFns } from "./simple-booking-rate-plan-modal.vue?vue&type=template&id=39e037d6&scoped=true&"
import script from "./simple-booking-rate-plan-modal.vue?vue&type=script&lang=js&"
export * from "./simple-booking-rate-plan-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e037d6",
  null
  
)

export default component.exports